/**
 * V2 site banner — the admin-set message (app_settings.banner_message),
 * linkified like V1, dismissible per message text (a new message shows
 * again even if an older one was dismissed).
 */
import { linkifyText } from '../../assets/js/utils.js';

const DISMISS_KEY = 'yoink_banner_dismissed';

function messageKey(message) {
  let hash = 0;
  for (let i = 0; i < message.length; i++) hash = (hash * 31 + message.charCodeAt(i)) | 0;
  return String(hash);
}

export function mount(el, ctx) {
  const { store } = ctx;

  function render(state) {
    const message = state.bannerMessage;
    let dismissed = null;
    try {
      dismissed = localStorage.getItem(DISMISS_KEY);
    } catch {
      // private mode
    }
    if (!message || dismissed === messageKey(message)) {
      el.innerHTML = '';
      return;
    }
    el.innerHTML = `
      <div class="v2-banner" role="status">
        <span class="v2-banner-text">${linkifyText(message)}</span>
        <button type="button" class="v2-banner-close" data-banner-dismiss aria-label="Dismiss message">✕</button>
      </div>`;
  }

  function onClick(event) {
    if (!event.target.closest('[data-banner-dismiss]')) return;
    const message = store.get().bannerMessage || '';
    try {
      localStorage.setItem(DISMISS_KEY, messageKey(message));
    } catch {
      // private mode — session dismiss only
    }
    el.innerHTML = '';
  }

  el.addEventListener('click', onClick);
  const unsubscribe = store.subscribe(render);
  render(store.get());

  return () => {
    el.removeEventListener('click', onClick);
    unsubscribe();
  };
}
